import PlayerData from '../enums/PlayerData';
import { IframeMessengerable } from '../IframeMessengerPlayerAbstract';
import { SystemInformationInterface } from '../interfaces/SystemInformationInterface';
import { SystemInformation, SystemInformationMessage } from '../types';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function SystemInformationQueryable<TBase extends IframeMessengerable>(Base: TBase) {
    return class SystemInformationQueryable extends Base implements SystemInformationInterface {
        /**
         * Gets system information of the platform
         */
        async getSystemInformation(): Promise<SystemInformation> {
            const data = await this._getData<SystemInformationMessage>(
                PlayerData.SYSTEM_INFORMATION
            );

            const information: SystemInformation = {
                HardwareInfo: {
                    Manufacturer: data.hardware.manufacturer,
                    Model: data.hardware.model,
                },
                OperatingSystemInfo: {
                    Name: data.os.name,
                    Manufacturer: data.os.manufacturer,
                    Version: data.os.version,
                },
            };

            return information;
        }
    };
}
